module.exports = __webpack_public_path__ + "static/media/35-4.fa07f58d.mp3";